export const getSetting = (settings, prop, row="value") => {
    settings = settings.filter( el => ({...el}))
    let res = null
    res = settings.filter( el => el.prop.includes(prop))
    return res.length > 0 ? res[0][row] : null
}